import React from 'react';
import PropTypes from 'prop-types';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import { trackV2 } from 'utils/analytics';
import { checkoutUrl } from '../../helpers.js';

import styles from './index.scss';
import ContinueButton from './ContinueButton';

export class Footer extends React.Component {
  getCheckoutUrl = () => {
    const { option, trialInfo, origin } = this.props;
    return checkoutUrl({ packageIds: option.packageIds, trialInfo, origin });
  };

  getPriceWithoutDiscountText = () => {
    return (
      <s>
        <span className={styles.amount}>
          {Cldr.formatCurrency(
            this.props.option.priceWithoutDiscount,
            this.props.option.currency
          )}
        </span>
        {I18n.t('strava.premium.package_select.footer.per_month')}
      </s>
    );
  };

  getPriceWithDiscountText = () => (
    <>
      <b className={styles.amount}>
        {Cldr.formatCurrency(
          this.props.option.priceWithDiscount,
          this.props.option.currency
        )}
      </b>
      {I18n.t('strava.premium.package_select.footer.per_month')}
    </>
  );

  handleContinueClick = () => {
    trackV2({
      category: 'summit_upsell',
      page: 'checkout',
      action: 'click',
      element: 'continue_to_billing',
      properties: {
        origin: this.props.origin,
        subscription_type: this.props.trialInfo ? 'trial' : 'organic'
      }
    });
  };

  renderHasSelected = () => {
    return (
      <div className={styles.footerSummary}>
        <div className={styles.price}>
          <div className={styles.row}>{this.getPriceWithoutDiscountText()}</div>
          <div className={styles.row}>{this.getPriceWithDiscountText()}</div>
          <div className={styles.row}>
            <small>
              {I18n.t(
                'strava.premium.package_select.footer.when_billed_yearly'
              )}
            </small>
          </div>
        </div>
        <div className={styles.actions}>
          <ContinueButton
            destination={this.getCheckoutUrl()}
            buttonText={I18n.t(
              'strava.premium.package_select.footer.cta_continue'
            )}
            clickHandler={this.handleContinueClick}
          />
        </div>
      </div>
    );
  };

  renderTrialContent = () => {
    const { option, trialInfo } = this.props;
    const continueButtonText = trialInfo
      ? I18n.t('strava.premium.package_select.footer.cta_trial', {
          days: trialInfo.trialLength
        })
      : I18n.t('strava.premium.package_select.footer.cta_continue');

    return (
      <div className={styles.trialFooter}>
        <div className={styles.priceBreakdown}>
          <div className={styles.price}>
            <div className={styles.priceDescription}>
              {I18n.t('strava.premium.package_select.footer.trial.free_trial')}
            </div>
            <div className={styles.priceDevider} />
            <div className={styles.priceAmount}>
              {Cldr.formatCurrency(0, option.currency)}
            </div>
          </div>
          <small>
            {I18n.t(
              'strava.premium.package_select.footer.trial.per_month_after',
              {
                amount: Cldr.formatCurrency(
                  option.priceWithDiscount,
                  option.currency
                ),
                days: trialInfo.trialLength
              }
            )}
          </small>
        </div>
        <div className={styles.actions}>
          <ContinueButton
            destination={this.getCheckoutUrl()}
            buttonText={continueButtonText}
            clickHandler={this.handleContinueClick}
          />
          <small>
            {I18n.t('strava.premium.package_select.footer.when_billed_yearly')}
          </small>
        </div>
      </div>
    );
  };

  renderFooter = () => {
    const { trialInfo } = this.props;

    if (trialInfo) {
      return this.renderTrialContent();
    }

    return this.renderHasSelected();
  };

  render() {
    return <div className={styles.footer}>{this.renderFooter()}</div>;
  }
}

Footer.propTypes = {
  origin: PropTypes.string.isRequired,
  option: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    packageIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    discountPercent: PropTypes.number.isRequired,
    priceWithoutDiscount: PropTypes.number.isRequired,
    priceWithDiscount: PropTypes.number.isRequired,
    allAccess: PropTypes.bool.isRequired
  }),
  trialInfo: PropTypes.shape({
    code: PropTypes.string,
    trialLength: PropTypes.number.isRequired
  })
};

Footer.defaultProps = {
  option: null,
  trialInfo: null
};

export default Footer;
